import { InstitutionTypeFilter } from '../../services/adapters/queries/institutionsQueryFunction';

interface VerticalCopy {
  institutionLabel: string;
  courseLabel: string;
  subtitle: string;
  contextLabel: string;
  homeOptionTitle: string;
  homeOptionSubtitle: string;
  coursesTitle: string;
  summary: (institutionCount: number, courseCount: number) => string;
}

export const verticalCopy: Record<InstitutionTypeFilter, VerticalCopy> = {
  university: {
    institutionLabel: 'Universidad',
    courseLabel: 'Materia',
    subtitle: 'Profes para tu carrera y materias de la facu.',
    contextLabel: 'Universidades',
    homeOptionTitle: 'Universidades',
    homeOptionSubtitle: 'Profes para tu carrera',
    coursesTitle: 'Materias dictadas',
    summary: (institutionCount, courseCount) =>
      `${institutionCount} universidades y ${courseCount} materias`
  },
  languages: {
    institutionLabel: 'Idioma',
    courseLabel: 'Nivel',
    subtitle: 'Profes para aprender idiomas a tu ritmo.',
    contextLabel: 'Idiomas',
    homeOptionTitle: 'Idiomas',
    homeOptionSubtitle: 'Profes para aprender idiomas',
    coursesTitle: 'Niveles dictados',
    summary: (institutionCount, courseCount) =>
      `${institutionCount} idiomas y ${courseCount} niveles`
  },
  schools: {
    institutionLabel: 'Año',
    courseLabel: 'Materia',
    subtitle: 'Profes para apoyo escolar en el secundario.',
    contextLabel: 'Colegios',
    homeOptionTitle: 'Colegios',
    homeOptionSubtitle: 'Apoyo escolar y materia',
    coursesTitle: 'Materias dictadas',
    summary: (institutionCount, courseCount) => `${institutionCount} años y ${courseCount} materias`
  },
  all: {
    institutionLabel: 'Institución',
    courseLabel: 'Curso',
    subtitle: 'Encontrá tu profe ideal.',
    contextLabel: 'Todas',
    homeOptionTitle: 'Todas',
    homeOptionSubtitle: 'Todas las verticales',
    coursesTitle: 'Cursos dictados',
    summary: (institutionCount, courseCount) =>
      `${institutionCount} instituciones y ${courseCount} cursos`
  }
};
